// Reports related store state and actions.
import axiosApiClient from "../../api/axiosApiClient"

export const reportTypes = ['EOD', 'DELIVERY_LOGS_V2']

const initialFilter = {
	type: reportTypes[0],
	pickupDateFrom: "",
	pickupDateTo: "",
	clientId: "",
	page: 1,
	limit: 20,
}

// State
export const state = {
	reportTypes,
	total: 0,
	lastPage: 0,
	result: [],
	filter: initialFilter,
}

// Mutations
export const mutations = {
	SET_REPORTS(state, { result, lastPage, total }) {
		state.result = result
		state.lastPage = lastPage
		state.total = total
	},
	SET_FILTER(state, filter) {
		state.filter = { ...state.filter, ...filter }
	}
}

// Getters
export const getters = {
}

// Actions
export const actions = {
	init({ dispatch }) {
		dispatch("resetFilter")
	},
	async generateReport({ commit, state, dispatch }, { filter, onFailed }) {
		try {
			const { data } = await axiosApiClient.post("/reports", filter)
			window.open(data.fileUrl)
		} catch(_) {
			onFailed()
		}
	},
	async getReports({ commit, state }, filter = {}) {
		try {
			const request = { ...state.filter, ...filter }
			const query = `type=${request.type}` +
					`&page=${request.page}` +
					`&pickupDateTo=${request.pickupDateTo}`  +
					`&limit=${request.limit}` +
					`${request.clientId ? "&clientId=" + request.clientId : ""}` +
					`${request.pickupDateFrom ? "&pickupDateFrom=" + request.pickupDateFrom : ""}`

			const { data } = await axiosApiClient.get("/reports?" + query)
			commit("SET_REPORTS", data)
			commit("SET_FILTER", request)
		} catch (_) {
			// do nothing
		}
	},
	updateFilter({ commit }, filter = {}) {
		commit("SET_FILTER", filter)
	},
	resetFilter({ commit, rootGetters, rootState }) {
		if (rootGetters["auth/isAdmin"]) {
			commit("SET_FILTER", initialFilter)
		} else {
			const clientInitialFilter = { ...initialFilter, ...rootState.auth.currentClient ? { clientId: rootState.auth.currentClient.id } : {} }
			commit("SET_FILTER", clientInitialFilter)
		}
	}
}
